import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { useTranslation } from 'react-i18next';

RoadMap.propTypes = {
    data: PropTypes.array,
};

const STEP_MS = 5200;

function RoadMap(props) {
    const { data } = props;
    const { t } = useTranslation();

    const [active, setActive] = useState(0);
    const [playing, setPlaying] = useState(false);
    const sectionRef = useRef(null);
    const timerRef = useRef(null);

    // Bo'lim ekranga kirganda animatsiya boshlanadi
    useEffect(() => {
        const node = sectionRef.current;
        if (!node || typeof IntersectionObserver === 'undefined') {
            setPlaying(true);
            return undefined;
        }

        const observer = new IntersectionObserver(
            ([entry]) => setPlaying(entry.isIntersecting),
            { threshold: 0.25 }
        );

        observer.observe(node);
        return () => observer.disconnect();
    }, []);

    // Avtomatik ketma-ketlik
    useEffect(() => {
        if (!playing) return undefined;

        timerRef.current = setInterval(() => {
            setActive((i) => (i + 1) % data.length);
        }, STEP_MS);

        return () => clearInterval(timerRef.current);
    }, [playing, data.length, active]);

    const select = useCallback((idx) => {
        clearInterval(timerRef.current);
        setActive(idx);
    }, []);

    const current = data[active];
    const progress = ((active + 1) / data.length) * 100;

    return (
        <section id='hamkorlik' className="tf-section process" ref={sectionRef}>
            <div className="container">
                <div className="tf-title st2 mb-50" data-aos="fade-up" data-aos-duration="800">
                    <p className="h8 sub-title">{t('work-sequence')}</p>
                    <h2 className="title">{t('work-sequence-2')}</h2>
                </div>

                {/* Bosqichlar relsi */}
                <div className="process-rail" role="tablist">
                    <div className="process-rail__line">
                        <span className="process-rail__fill" style={{ width: `${progress}%` }} />
                    </div>

                    <div className="process-rail__dots">
                        {data.map((item, idx) => (
                            <button
                                key={item.id}
                                type="button"
                                role="tab"
                                aria-selected={idx === active}
                                aria-label={t(item.time)}
                                className={`process-dot${idx === active ? ' is-active' : ''}${idx < active ? ' is-done' : ''}`}
                                onClick={() => select(idx)}
                            >
                                <span className="process-dot__num">{String(idx + 1).padStart(2, '0')}</span>
                            </button>
                        ))}
                    </div>
                </div>

                {/* Faol bosqich paneli */}
                <div className="process-stage">
                    <div className="process-stage__index" key={`n-${active}`}>
                        {String(active + 1).padStart(2, '0')}
                        <span className="process-stage__total">/{String(data.length).padStart(2, '0')}</span>
                    </div>

                    <div className="process-stage__body" key={`b-${active}`}>
                        <h3 className="process-stage__title">{t(current.time)}</h3>
                        {current.list.map((li, idx) => (
                            <p key={idx} className="process-stage__text">{t(li.text)}</p>
                        ))}

                        <div className="process-stage__bar">
                            <span
                                className={playing ? 'is-running' : ''}
                                key={`p-${active}-${playing}`}
                                style={{ animationDuration: `${STEP_MS}ms` }}
                            />
                        </div>
                    </div>

                    <span className="brand-asterisk process-stage__mark">&#10033;</span>
                </div>

                {/* Barcha bosqichlar — pill chiplar */}
                <div className="process-chips">
                    {data.map((item, idx) => (
                        <button
                            key={item.id}
                            type="button"
                            className={`process-chip${idx === active ? ' is-active' : ''}`}
                            onClick={() => select(idx)}
                        >
                            <span className="process-chip__plus">+</span>
                            {t(item.time)}
                        </button>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default RoadMap;
